/**
 * PromptMySite Widget - Embed Script Entry Point
 *
 * This file re-exports from the embed/ folder for better maintainability.
 * See embed/index.ts for the main entry point.
 *
 * Usage:
 * <script
 *   src="https://cdn.promptmysite.com/embed.js"
 *   data-workspace="your-workspace-id"
 *   data-style="bubble"
 *   data-position="bottom-right"
 * ></script>
 */

// =============================================================================
// SIDE-EFFECT IMPORTS (Block Registrations)
// =============================================================================

// Force side-effect imports to ensure all block renderers are registered
import './ui/blocks/content';
import './ui/blocks/data-display';
import './ui/blocks/feedback';
import './ui/blocks/cards';
import './ui/blocks/interactive';
import './ui/blocks/flow-form';
// MOTHBALLED: Endpoint-driven blocks disabled for delivery simplification.
// import './ui/blocks/live-section';
import './ui/blocks/media';
import './ui/blocks/organization';
import './ui/blocks/specialized';
// MOTHBALLED: Endpoint-driven blocks disabled for delivery simplification.
// import './ui/blocks/browse';
import './ui/blocks/templates'; // Composite templates (detail-page, browse-form, etc.)
import './ui/blocks/booking-management'; // Booking management (self-service reschedule/cancel)
// Note: custom-templates.ts is imported dynamically when custom blocks are loaded

// =============================================================================
// IMPORTS
// =============================================================================

import { exposeGlobalApi } from './embed/global-api';
import { setupAutoInit } from './embed/script-init';

// =============================================================================
// INITIALIZATION (Side Effects - Must Run!)
// =============================================================================

// Expose global API immediately (before DOM ready)
exposeGlobalApi();

// Set up auto-init from script tag when DOM is ready
setupAutoInit();

// =============================================================================
// EXPORTS
// =============================================================================

// Re-export everything from the embed module
export * from './embed/index';
